<template>
  <div class="back-btn" @click="onBackClick">
    <i class="el-icon-back"></i>
  </div>
</template>

<script>
export default {
  name: "BackIcon",
  methods: {
    onBackClick() {
      this.$router.back()
    }
  }
}
</script>

<style scoped lang="less">
.back-btn {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #fff;
  box-shadow: var(--shadow-card);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s ease;

  i {
    font-size: 26px;
    font-weight: 600;
    color: var(--text-1);
  }

  &:hover {
    color: var(--brand-primary);
    box-shadow: var(--shadow-card-hover);
    transform: translateX(-3px);

    i {
      color: var(--brand-primary);
    }
  }
}
</style>
